import React from "react";

import{
    doFlex,
    padT40,
    minimalFeature,
    justifySpaceBetween,
    flexWrap,
    textCenter,
} from './main.module.scss'

var minifeatures = []

var minifeature = [
    {
        head: 'DDOS Protection',
        desc: 'Get peace of mind, knowing network security and DDoS protection is monitored around the clock'
    },
    {
        head: 'Industry’s leading control Panel',
        desc: 'Flexbox is a one-dimensional layout mode that allows you to align.'
    },
    {
        head: 'Daily Backups',
        desc: 'Help protect against disasters and mishaps by recovering your entire hosting account from the previous day with automated Daily Backups.'
    },
    {
        head: 'DDOS Protection',
        desc: 'Get peace of mind, knowing network security and DDoS protection is monitored around the clock'
    },
    {
        head: 'Industry’s leading control Panel',
        desc: 'Flexbox is a one-dimensional layout mode that allows you to align.'
    },
    {
        head: 'Daily Backups',
        desc: 'Help protect against disasters and mishaps by recovering your entire hosting account from the previous day with automated Daily Backups.'
    },
]

const dedifeatures = [
  {
      head: '99.99+% Power and Network Uptime',
      desc: 'Experience exceptional reliability with our dedicated servers, ensuring your business stays online with no downtime.'
  },
  {
      head: 'Unlimited OS Reload',
      desc: 'Enjoy the flexibility of unlimited operating system reloads, allowing you to customize and optimize your server environment as needed.'
  },
  {
      head: 'Best Enterprise Grade Hardware',
      desc: 'Benefit from top-of-the-line enterprise-grade hardware, delivering superior performance, stability, and scalability for your critical applications.'
  },
  {
      head: '24x7x365 Support',
      desc: 'Our expert support team is available round-the-clock, ready to assist you with any server-related issues or concerns, ensuring seamless operations and peace of mind.'
  },
  {
      head: 'Bring Your Own IP',
      desc: 'Have the freedom to bring and use your own IP addresses, enabling seamless integration with existing infrastructure and network configurations.'
  },
  {
      head: 'Rent to Own Server Options',
      desc: 'Explore our rent-to-own server options, allowing you to gradually own the dedicated server over time while enjoying its benefits from the start.'
  },
]

const HomeServices = [
  {
      head: 'Reseller Hosting',
      desc: 'We provide the best reseller hosting with full root access. You can create, resize and delete your accounts as you wish.'
  },
  {
      head: 'Cloud Service',
      desc: 'Unlock the power of the cloud – scalable infrastructure, high availability, and flexible resources for your business.'
  },
  {
      head: 'Domain Name',
      desc: 'Secure your online identity with the perfect domain name with easy registration, effortless management, and professional branding.'
  },
  {
      head: 'SSL Certificate',
      desc: 'Secure your website with SSL certificates for strong encryption, trust, and peace of mind in online communication.'
  },
  {
      head: 'NodeJS Application Hosting',
      desc: 'Host your Node.js applications with ease, offering scalable infrastructure, optimal performance, and seamless deployment.'
  },
  {
      head: 'DevOps Services',
      desc: 'Streamline your development and operations with our comprehensive DevOps services, enabling efficient collaboration and accelerated delivery.'
  },
]

var webHosting = [
  {
      head: 'Free SSL Certificates',
      desc: 'Secure your website with free SSL certificates, ensuring data encryption and building trust with your visitors.'
  },
  {
      head: '1-click App Installer',
      desc: 'Install popular applications with just a single click, making it easy to set up your website, blog, or online store.'
  },
  {
      head: 'Free Website Migration',
      desc: 'Seamlessly transfer your existing website to BigBoxHost at no additional cost, ensuring a smooth transition.'
  },
  {
      head: 'Weekly Backups',
      desc: 'Enjoy peace of mind with weekly backups, safeguarding your website data and allowing easy recovery if needed.'
  },
  {
      head: 'Industry’s Leading Control Panel',
      desc: 'Manage your website effortlessly with the cPanel control panel, offering intuitive and powerful website management tools.'
  },
  {
      head: 'Optimized Web Server',
      desc: 'Experience superior website performance with an optimized web server, ensuring fast loading speeds and a smooth browsing experience for your visitors.'
  },
]

var cloudBusinessHosting = [
  {
    head: 'Unlimited Website Migration',
    desc: 'Seamlessly transfer your existing all websites to BigBoxHost at no additional cost, ensuring a smooth transition.'
  },
  {
      head: 'Free Premium SSL Certificates',
      desc: 'Unlike shared hosting get, with business cloud hosting get a premium 1 year SSL certificate with warranty of $50,000.'
  },
  {
    head: 'Dedicated Backups Storage',
    desc: 'Enjoy peace of mind with robust dedicated backups service, safeguarding your website data and allowing easy recovery if needed.'
  },
  {
      head: 'Industry’s Leading Control Panel',
      desc: 'Manage your website effortlessly with the cPanel control panel, offering intuitive and powerful website management tools.'
  },
  {
      head: 'Easy Application Installer',
      desc: 'Install popular applications with just a single click, making it easy to set up your website, blog, or E-commerce store.'
  },
  {
      head: 'Dedicated Resources',
      desc: 'With our cloud business hosting, enjoy exclusive access to dedicated CPU, RAM, IOPS, IP address, and other resources for enhanced performance and scalability.'
  },
]

var resellerHosting = [
  {
    head: 'Free Dedicated Server Upgrade',
    desc: 'Get a free upgrade to a dedicated server once you grow to 400+ cPanel accounts. This way you will get all dedicated resources for your reseller accounts as well.'
  },
  {
    head: 'Free WHMCS License',
    desc: 'Streamline your business operations with a complimentary WHMCS license included in our reseller hosting package.'
  },
  {
      head: 'Free WHM Reseller API',
      desc: 'Easily manage your reseller accounts and customers through the WHM API, with full access to all functions and features.'
  },
  {
      head: 'No Resource Limitations',
      desc: 'Enjoy extreme performance and unlimited possibilities with no resource limitations on our reseller hosting platform.'
  },
  {
      head: '1-Click Application Installer',
      desc: 'Simplify installation and setup with our convenient 1-click application installer for reseller hosting.'
  },
  {
      head: "Industry's Best Control Panel",
      desc: 'Take control with confidence using the cPanel control panel for managing your reseller hosting accounts.'
  },
  {
    head: "Free SSL Certificate",
    desc: 'Secure all your customers with a free SSL certificate, ensuring your customers data is protected.'
  },
  {
    head: "White-Labeled Hosting",
    desc: "Offer your own branded hosting service with our white-label reseller hosting platform, providing your customers with a seamless experience."
  },
  {
    head: "99.9% Uptime Guarantee",
    desc: "Rest assured with our 99.9% uptime guarantee, backed by our state-of-the-art data centers and world-class network infrastructure."
  },
]

var rootresellerHosting = [
  {
    head: '100% Dedicated Resources',
    desc: 'With our root reseller hosting service, you will get access to total server resources at your disposal.'
  },
  {
    head: 'Free Dedicated IP',
    desc: 'Get a free dedicated IP address with each of your reseller hosting accounts, allowing you to run multiple websites with ease.'
  },
  {
      head: 'Free Domain Reseller Account',
      desc: 'Resell domains without any hassle, with a free domain reseller Accoount included in your root reseller hosting package. '
  },
  {
    head: 'Free WHMCS License',
    desc: 'Streamline your business operations with a complimentary WHMCS license included in our reseller hosting package.'
  },
  {
      head: 'No Resource Limitations',
      desc: 'Enjoy extreme performance and unlimited possibilities with no resource limitations on our reseller hosting platform.'
  },
  {
      head: '1-Click Application Installer',
      desc: 'Simplify installation and setup with our convenient 1-click application installer for reseller hosting.'
  },
  {
      head: "Industry's Best Control Panel",
      desc: 'Take control with confidence using the cPanel control panel for managing your reseller hosting accounts.'
  },
  {
    head: "Free SSL Certificate",
    desc: 'Secure all your customers with a free SSL certificate, ensuring your customers data is protected.'
  },
  {
    head: "White-Labeled Hosting",
    desc: "Offer your own branded hosting service with our white-label reseller hosting platform, providing your customers with a seamless experience."
  },
]

var boxServer = [
  {
    head: 'Dedicated Resources',
    desc: 'Enjoy the power of dedicated resources including CPU, RAM, and storage, ensuring optimal performance and stability for your applications and workloads.'
  },
  {
    head: 'Choice of OS',
    desc: 'With our root reseller hosting service, you will get access to total server resources at your disposal.'
  },
  {
    head: 'Instant Deployment',
    desc: 'Get started quickly with instant deployment of your virtual server, allowing you to provision and launch your server within minutes.'
  },
  {
      head: 'Easy Management',
      desc: 'Streamline server management with intuitive control panels and management tools, allowing you to efficiently monitor and control your virtual server, manage resources, and perform administrative tasks with ease.'
  },
  {
    head: 'Highly Scalable',
    desc: 'Scale your server resources seamlessly as your needs grow, with the ability to easily increase CPU, RAM, and storage capacity to accommodate your expanding requirements.'
  },
  {
    head: 'Robust Infrastructure',
    desc: 'Benefit from a robust infrastructure powered by state-of-the-art data centers, high-performance servers, and redundant network connectivity.'
  },
]

var domainName = [
  {
    head: 'Free Email Accounts',
    desc: 'Get access to free professional email accounts using your domain, allowing you to communicate effectively with a branded email address.'
  },
  {
    head: 'Easy DNS Management',
    desc: "Effortlessly manage and customize your domain's DNS settings, ensuring smooth and reliable connectivity to your website and other services."
  },
  {
    head: 'Domain Forwarding',
    desc: 'Easily redirect your domain to another URL, enabling seamless navigation and ensuring your visitors reach the right destination.'
  },
  {
      head: 'Management Control Panel',
      desc: 'Get user-friendly control panel, empowering you to manage DNS, email settings, and other domain-related configurations effortlessly.'
  },
  {
    head: 'Free Mail Forwarding',
    desc: 'Forward emails sent to your domain to any other email address, ensuring you never miss important messages while maintaining a centralized communication hub.'
  },
  {
    head: 'Privacy and security',
    desc: "Safeguard your domain's privacy and enhance its security with our robust measures, protecting your personal information and providing peace of mind for your online presence."
  },
]

var affiliateFeature = [
  {
    head: '90 Days Referral Cookie',
    desc: 'Earn commissions on referrals for up to 90 days after the initial click.'
  },
  {
    head: 'Easy Affiliate Tracking',
    desc: "Effortlessly track your referrals and earnings with our user-friendly affiliate dashboard."
  },
  {
    head: 'One-Click Payout',
    desc: 'Get paid quickly and conveniently with our seamless one-click payout system.'
  },
  {
      head: 'Low Minimum Payout Amount',
      desc: 'Cash out your earnings with ease, as we offer a low minimum payout threshold.'
  },
  {
    head: 'Earn Montlhy upto $360/sale',
    desc: 'Enjoy high earning with generous recurring commissions of up to $360 per qualified sale.'
  },
  {
    head: 'Unlimited Commission & Bonus',
    desc: "Sky's the limit! Earn unlimited commissions and unlock exciting bonus opportunities."
  },
]

const resellerProgramFeature = [
  {
    head: 'Priority Support',
    desc: "Benefit from top-notch support and fast response times with our priority support, ensuring that you and your clients receive timely assistance for any hosting-related queries or issues."
  },
  {
    head: 'Best In-class Pricing',
    desc: "Enjoy competitive and cost-effective pricing for our reseller program, giving you the opportunity to maximize your profits while offering affordable hosting solutions to your clients."
  },
  {
    head: 'Upfront Credit Options',
    desc: "Get upfront credit options to kickstart your reselling journey, allowing you to easily manage and allocate funds for purchasing hosting services and meeting the needs of your clients."
  },
  {
    head: 'White-Label Branding',
    desc: "Customize the hosting experience with your own branding, logo, and domain, offering a seamless and professional experience to your clients."
  },
  {
    head: 'Scalable Infrastructure',
    desc: "Easily scale your resources as your business grows, ensuring that you can accommodate the increasing demands of your clients without any hassle."
  },
  {
    head: 'Comprehensive Product Range',
    desc: "Access a wide range of hosting solutions and services, including shared hosting, VPS, cloud, dedicated servers, domain registration, and more, giving you the flexibility to meet the diverse needs of your clients."
  }
]

const contactoffices = [
  {
      head: 'Corporate Office',
      desc: <>BigBox Softwares LLC <br /> 4001 Tordera Drive <br />Austin, TX-78738 <br />USA</>
  },
  {
      head: 'Regional Office',
      desc: <>BigBox Network Inc <br /> 4001 Tordera Drive <br />Austin, TX-78738 <br />USA</>
  },
  {
      head: 'Branch Office',
      desc: <>BigBox Softwares LLC <br /> 4001 Tordera Drive <br />Austin, TX-78738 <br />USA</>
  },
]

const Minfeatures = ({center, pagename}) => {

  var centeralign = false
  if (center) {
    centeralign = true
  }

  if (pagename === 'dedicated'){
    minifeatures = dedifeatures
  } else if (pagename === 'home') {
    minifeatures = HomeServices
  } else if (pagename === 'webhosting') {
    minifeatures = webHosting
  } else if (pagename === 'cloudBusinessHosting') {
    minifeatures = cloudBusinessHosting
  } else if (pagename === 'resellerhosting') {
    minifeatures = resellerHosting
  } else if (pagename === 'rootresellerhosting') {
    minifeatures = rootresellerHosting
  } else if (pagename === 'boxserver') {
    minifeatures = boxServer
  } else if (pagename === 'domainname') {
    minifeatures = domainName
  } else if (pagename === 'affiliate') {
    minifeatures = affiliateFeature
  } else if (pagename === 'resellerprogram') {
    minifeatures = resellerProgramFeature
  } else if (pagename === 'contact') {
    minifeatures = contactoffices
  } else{
    minifeatures = minifeature
  }


  return (
    <div>
      <div className={`${doFlex} ${padT40} ${justifySpaceBetween} ${flexWrap}`}>
        {minifeatures.map((feature, index) => (
          <div className={`${minimalFeature} ${centeralign ? textCenter : null}`} key={index}>
            <h3>{feature.head}</h3>
            <p>{feature.desc}</p>
          </div>
        ))}
        </div>
    </div>
      )

};

export default Minfeatures